export const signUpAction = (data) => ({
  type: 'SIGN_UP',
  data: data,
});
